var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.fileMaxSize") } },
    [
      _c("el-input-number", {
        staticClass: "hide-spin-button",
        staticStyle: { width: "100%" },
        attrs: { min: 1 },
        model: {
          value: _vm.optionModel.fileMaxSize,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "fileMaxSize", $$v)
          },
          expression: "optionModel.fileMaxSize",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }